import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function FinalClose() {
  const {
    language
  } = useLanguage();
  const t = translations[language].finalClose;
  const scrollToBook = () => {
    const bookSection = document.getElementById('book-section');
    if (bookSection) {
      bookSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <div className="mb-12 -mx-4" data-id="element-24">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FUjSzCkGVfLb7AuzFFqL3/CONTRA_PORTADA.png" alt="Book Back Cover" className="w-full rounded-lg shadow-2xl shadow-teal-500/30" data-id="element-25" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-white" data-id="element-26">
          {t.title}
        </h2>
        <div className="space-y-4 mb-12" data-id="element-27">
          {t.points.map((point, index) => <div key={index} className="flex items-center gap-4 p-4 bg-gradient-to-r from-teal-950/50 to-black border border-teal-600/30 rounded-xl" data-id="element-28">
              <CheckIcon className="w-8 h-8 text-teal-400 flex-shrink-0" data-id="element-29" />
              <p className="text-xl text-gray-200" data-id="element-30">{point}</p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-31">
          <h3 className="text-3xl font-bold mb-8 text-yellow-400" data-id="element-32">
            {t.heading}
          </h3>
          <button onClick={scrollToBook} className="relative overflow-hidden w-full max-w-md mx-auto bg-gradient-to-r from-red-600 to-red-700 md:from-red-600 md:to-red-700 text-white px-8 py-5 rounded-full text-lg md:text-xl font-bold hover:from-red-500 hover:to-red-600 transform hover:scale-105 transition-all animate-pulse-glow mb-8 before:content-[''] before:absolute before:inset-0 before:bg-gradient-to-r before:from-red-500 before:via-transparent before:to-red-700 before:opacity-0 md:before:opacity-100 after:content-[''] after:absolute after:left-0 after:top-0 after:bottom-0 after:w-1/2 after:bg-red-500 after:rounded-l-full after:md:hidden" data-id="element-33">
            <span className="relative z-10" data-id="element-34">{t.cta}</span>
          </button>
          <p className="mb-8 text-xs text-gray-400" data-id="element-35">{t.guarantee}</p>
          <div className="bg-gradient-to-br from-yellow-950/30 to-black border border-yellow-600/30 rounded-xl p-8" data-id="element-36">
            <p className="text-xl italic text-teal-200" data-id="element-37">
              {t.ps}{' '}
              <span className="text-yellow-400 font-bold" data-id="element-38">{t.psHighlight}</span>
            </p>
          </div>
        </div>
      </div>
      <style data-id="element-39">{`
        @keyframes pulse-glow {
          0%, 100% {
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.5), 0 0 40px rgba(59, 130, 246, 0.3), 0 0 60px rgba(59, 130, 246, 0.2);
          }
          50% {
            box-shadow: 0 0 30px rgba(59, 130, 246, 0.8), 0 0 60px rgba(59, 130, 246, 0.5), 0 0 90px rgba(59, 130, 246, 0.3);
          }
        }
        .animate-pulse-glow {
          animation: pulse-glow 3s ease-in-out infinite;
        }
      `}</style>
    </section>;
}